import { HttpResponse } from '@angular/common/http';

/**
 * Výsledek urgence (EL-2333). Tělo odpovědi je dál holé číslo odeslaných — změnou na
 * objekt by se rozbil už nasazený frontend. Kolik lidí server přeskočil, protože stejnou
 * urgenci dostali v posledních 24 hodinách, nese hlavička `X-Reminder-Skipped`.
 */
export interface ReminderResult {
  sent: number;

  skipped: number;
}

export const REMINDER_SKIPPED_HEADER = 'X-Reminder-Skipped';

/** Složí výsledek z odpovědi serveru; chybějící hlavička znamená nikoho přeskočeného. */
export function reminderResultOf(response: HttpResponse<number>): ReminderResult {
  return {
    sent: response.body ?? 0,
    skipped: Number(response.headers.get(REMINDER_SKIPPED_HEADER) ?? 0) || 0,
  };
}
